import { ICallerDetail, ICallerHistoryEntry } from '../types';
import {
  Card,
  SectionLabel,
  HistoryList,
  HistoryEntry,
  HistoryTop,
  HistoryText,
  HistoryStaff,
  HistoryNote,
  RebookChip,
  CenterRow,
  Chip,
} from './detail-styles';
import chevronDownIcon from '../icons/chevron-down.svg';

type Props = {
  detail: ICallerDetail;
  onRebook?: (entry: ICallerHistoryEntry) => void;
  onSeeMore?: () => void;
  rebookDisabled?: boolean; // true while a staff-availability check is running
};

// HISTORY section — previews the 2 most recent visits with a Re Book chip;
// "See more" opens the full BOOKING HISTORY modal.
const HistorySection = ({ detail, onRebook, onSeeMore, rebookDisabled }: Props) => (
  <Card>
    <SectionLabel>HISTORY</SectionLabel>
    <HistoryList>
      {detail.history.slice(0, 2).map((entry, i) => (
        <HistoryEntry key={`${entry.date}-${i}`}>
          <HistoryTop>
            <HistoryText>
              <span className="date">{entry.date}</span>
              <span className="ser">{`Ser: ${entry.services}`}</span>
              {/* Missing name = the staff was deleted — show nothing rather than a bare id. */}
              {entry.staff && (
                <HistoryStaff>
                  {entry.staffAvatar && <img src={entry.staffAvatar} alt="" />}
                  <span className="name">{entry.staff}</span>
                </HistoryStaff>
              )}
            </HistoryText>
            <RebookChip type="button" disabled={rebookDisabled} onClick={() => onRebook?.(entry)}>
              Re Book
            </RebookChip>
          </HistoryTop>
          {entry.note && (
            <HistoryNote>
              <span className="label">Note:</span> {entry.note}
            </HistoryNote>
          )}
        </HistoryEntry>
      ))}
    </HistoryList>
    <CenterRow>
      <Chip type="button" onClick={onSeeMore}>
        See more
        <img src={chevronDownIcon} alt="" />
      </Chip>
    </CenterRow>
  </Card>
);

export default HistorySection;
